  const targetTime = new Date().getTime() + 10 * 60 * 1000;
  function updateTimer() {
      const currentTime = new Date().getTime();
      const timeRemaining = targetTime - currentTime;
      if (timeRemaining <= 0) {
          document.getElementById("mtime").textContent = "00:00";
      } else {
          const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
          const seconds = Math.floor((timeRemaining / 1000) % 60);
          document.getElementById("mtime").textContent = `${minutes}m ${seconds}s`;
      }
  }
  setInterval(updateTimer, 1000);
        document.addEventListener("DOMContentLoaded", function() {
        updateTimer();
      });

function initializeSwiper() {
    var swiper = new Swiper(".M-review-slider", {
      spaceBetween: 30,
      autoplay: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        348: {
          centeredSlides: true,
          slidesPerView: 1.2,
          spaceBetween: 20,
          centeredSlidesBounds: true,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.6,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3.25,
          spaceBetween: 30,
        }
      }
    });
  }

  // Sticky ATC
function isElementMovedUpAndOutOfViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.bottom <= 0 &&
        rect.top < window.innerHeight
    );
}

function checkVisibility() {
    let ogPaymentElement = document.querySelector(".og-payment");
    let stickyatc = document.querySelector("#cstm-sticky-bar");
    if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
        stickyatc.classList.add("mvisible");
    } else {
        stickyatc.classList.remove("mvisible");
    }
}  
  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility); // Listen for window resize
  checkVisibility();

  function updatePriceNimageSticky()
{
  var getData = document.querySelector('div#cstm-sticky-bar select.select__select').selectedOptions[0].dataset;
  var image = getData.image;
  var price = getData.price;
  var cprice = getData.cprice;
  
  if(document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb'))
  document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb').src= image;
    
  if(document.querySelector('div#cstm-sticky-bar span.price-item.price-item--sale'))
  document.querySelector('div#cstm-sticky-bar span.price-item.price-item--sale').innerHTML= price;
   
  if(document.querySelector('div#cstm-sticky-bar s.price-item.price-item--regular'))
  document.querySelector('div#cstm-sticky-bar s.price-item.price-item--regular').innerHTML= cprice;
}

  function toggleMActiveClass() {
    var elements = document.getElementsByClassName("m-textwrap");
    for (var i = 0; i < elements.length; i++) {
        elements[i].classList.toggle("mactive");
    }
}

function startAnnouncement() {
    // Execute immediately
    toggleMActiveClass();

    // Set up the interval
    setInterval(function() {
        toggleMActiveClass();
    }, 3000);
}